import numeral from 'numeral';
import store from '~/javascripts/store.js';
import t from '~/javascripts/utils/translation';
import { Component } from 'react';
import { observer } from 'mobx-react';

const AmountStepText = observer(
  class AmountStepText extends Component {
    text = () => {
      if (store.donateForm.customAmountStepText) {
        return store.donateForm.customAmountStepText;
      }

      if (this.useGenericText()) {
        return t('views.inline_giving_calculator.generic_text', {
          subscription_period: store.donateForm.subscriptionPeriod,
        });
      }

      return t('views.inline_giving_calculator.text', {
        number_of_people: this.formattedPeopleServed(),
        currency_unit: store.donateForm.currencyUnit,
        amount: this.formattedDonationAmount(),
        subscription_period: store.donateForm.subscriptionPeriod,
      });
    };

    useGenericText() {
      const genericTextMinAmount = {
        us: 7,
        uk: 5,
      }[store.donateForm.country];

      return (
        isNaN(store.donateForm.amount) ||
        store.donateForm.amount <= genericTextMinAmount
      );
    }

    formattedDonationAmount = () =>
      numeral(store.donateForm.amount).format('0,0.00');

    formattedPeopleServed = () => {
      const annualAmount = store.donateForm.isAnnual
        ? store.donateForm.amount
        : store.donateForm.amount * 12;
      const peopleServed = Math.floor(annualAmount / this.props.costPerPerson);
      return numeral(peopleServed).format('0,0');
    };

    render() {
      return (
        <div className='inline-calculator text-xs text-cw-black p-2 border-dashed border-0 border-t border-grey-30 leading-normal'>
          <span
            className='subtext'
            dangerouslySetInnerHTML={{ __html: this.text() }}
          />
        </div>
      );
    }
  }
);

export default AmountStepText;
